/**
 * Escapes HTML special characters to prevent XSS attacks.
 * @param text - The text to escape (any type, will be converted to string)
 * @returns The escaped string, or empty string for null/undefined
 */
export function escapeHtml(text: unknown): string {
  if (text === undefined || text === null) return '';
  return String(text).replace(/[&<>"']/g, (char) => {
    switch (char) {
      case '&':
        return '&amp;';
      case '<':
        return '&lt;';
      case '>':
        return '&gt;';
      case '"':
        return '&quot;';
      case "'":
        return '&#39;';
      default:
        return char;
    }
  });
}
